import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class CreateCampaignDialogCountryMixin extends Vue {
  countryCondition({form, item, id} : {form:any, item: any, id?: string}) {
   const {countryId} = form
   return countryId == 0 || item.countryId == 0 || countryId == item.countryId || (id && item.id === id);
  }

  getCountryName(countryId: number) {
    let result = '';

    let country = this.$store.getters.countryListPlusGlobal.find((item: any) => item.id === countryId);
    if (country) {
      result = country.name;
    }

    return result
      ? result
      : this.t('Global');
  }
}